export default __webpack_public_path__ + "static/media/dental-icon.1bb72ec3.svg";